import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ShortlistBtn.css';
import React, { useEffect } from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../../utils';
import { deleteVenuesApi, saveVenuesApi } from '../../../utils/venues';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var ShortlistBtn = function ShortlistBtn(_ref) {
  var checked = _ref.checked,
    id = _ref.id,
    sitecoreContext = _ref.sitecoreContext,
    title = _ref.title,
    analytics = _ref.analytics,
    params = _ref.params,
    dynamicColor = _ref.dynamicColor,
    dynamicColorActive = _ref.dynamicColorActive;
  id = id.toLowerCase();
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedActivePrimaryColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  if (canUseDOM && !checked) {
    var ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
    checked = ids.some(function (itemId) {
      return itemId === id;
    });
  }
  var _React$useState3 = React.useState(checked),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isChecked = _React$useState4[0],
    setChecked = _React$useState4[1];
  useEffect(function () {
    if (canUseDOM) {
      var triggerUpdate = function triggerUpdate() {
        var svids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
        setChecked(svids.some(function (svid) {
          return svid === id;
        }));
      };
      triggerUpdate();
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return function () {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, [isChecked]);
  var onChange = function onChange(event) {
    setChecked(!isChecked);
    if (!isChecked) {
      if (analytics.add) {
        tealiumClickFunc(tealiumMergeClickData(analytics.add, params || {}), title);
      }
    } else {
      if (analytics.remove) {
        tealiumClickFunc(tealiumMergeClickData(analytics.remove, params || {}), title);
      }
    }
    if (canUseDOM) {
      var _ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      var ok = function ok() {
        localStorage.setItem('shortlistVenues', JSON.stringify(_ids));
        document.body.dispatchEvent(new Event('shortlistVenues'));
      };
      if (!isChecked) {
        if (!_ids.some(function (sv) {
          return sv === id;
        })) {
          saveVenuesApi(sitecoreContext, [id]).then(function (response) {
            if (!response || !response.errors) {
              _ids.push(id);
              ok();
            } else {
              setChecked(false);
            }
          });
        }
      } else {
        _ids = _ids.filter(function (sv) {
          return sv !== id;
        });
        deleteVenuesApi(sitecoreContext, [id]).then(function (response) {
          if (!response || !response.errors) {
            ok();
          } else {
            setChecked(true);
          }
        });
      }
    }
  };
  var variables = {
    "--shortlist-btn-primary-color": dynamicColor ? dynamicColor : selectedPrimaryColor,
    "--shortlist-btn-active-color": dynamicColorActive ? dynamicColorActive : selectedActivePrimaryColor
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " article__icon shortlist__icon"),
    style: variables
  }, /*#__PURE__*/React.createElement("label", {
    className: "my-icon-white",
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isChecked,
    onChange: onChange,
    onTouchEnd: function onTouchEnd(e) {
      return e.preventDefault();
    },
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("svg", {
    className: "my-icon-white__svg-first",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Zm-6.685-6.791a.392.392,0,0,1,.2.065l6.043,5.431v-16.9a1.728,1.728,0,0,0-1.635-1.813H28.111a1.728,1.728,0,0,0-1.635,1.813v16.9l6.043-5.431A.392.392,0,0,1,32.723,31.791Z",
    transform: "translate(-25.6 -17.6)",
    fill: "#007cba",
    stroke: "#007cba",
    "stroke-width": "0.8"
  }))))), /*#__PURE__*/React.createElement("svg", {
    className: "my-icon-white__svg-second",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Z",
    transform: "translate(-25.6 -17.6)",
    "stroke-width": "0.8"
  })))))));
};
var commonStyles = "cjq8uwa";
export default ShortlistBtn;